const e = {
  none: "0",
  xsmall: "0.25rem",
  // 4px
  small: "0.5rem",
  // 8px
  medium: "0.75rem",
  // 12px
  large: "1.25rem",
  // 20px
  pill: "3.75rem",
  // 60px
  circle: "9999px",
  inherit: "inherit"
};
export {
  e as default
};
